export const messages = {
  en: {
    carCreateFee: {
      queryCondition: "Query Conditions",
      parkingSpacePlaceholder: "Please fill in parking lot-space, e.g. 1-101",
      carNumPlaceholder: "Please fill in license plate number",
      ownerNamePlaceholder: "Please fill in owner name",
      parkingSpaceStatus: "Parking space status",
      query: "Query",
      reset: "Reset",
      vehicleCharging: "Vehicle Charging",
      customTemplate: "Custom Template",
      customCreate: "Custom Create",
      batchCreate: "Batch Create",
      buyMonthlyCard: "Buy Monthly Card",
      licensePlate: "License Plate",
      parkingLot: "Parking Lot (Unit: No.)",
      parkingSpace: "Parking Space (Unit: No.)",
      ownerName: "Owner Name",
      contact: "Contact",
      status: "Status",
      operation: "Operation",
      viewCharges: "View Charges"
    },
    carCreateFeeAdd: {
      createFee: "Create Fee",
      chargeScope: "Charge Scope",
      requiredChargeScope: "Required, please select charge scope",
      community: "Community",
      parkingLot: "Parking Lot",
      vehicle: "Vehicle",
      feeType: "Fee Type",
      requiredFeeType: "Required, please select fee type",
      feeItem: "Fee Item",
      requiredFeeItem: "Required, please select fee item",
      chargeAmount: "Charge Amount",
      requiredChargeAmount: "Required, please fill in charge amount",
      parkingSpaceStatus: "Parking Space Status",
      sold: "Sold",
      rented: "Rented",
      startTime: "Billing Start Time",
      requiredStartTime: "Required, please fill in billing start time",
      endTime: "Billing End Time",
      requiredEndTime: "Required, please fill in billing end time",
      submit: "Submit",
      cancel: "Cancel"
    },
    exportCarFeeImportExcel: {
      templateExport: "Template Export",
      parkingLot: "Parking Lot",
      all: "All",
      parkingLotPlaceholder: "Parking Lot",
      feeItem: "Fee Item",
      export: "Export",
      cancel: "Cancel"
    },
    doImportCreateFee: {
      customCreateFee: "Custom Create Fee",
      selectFile: "Select File",
      requiredFile: "Required, please select data file",
      import: "Import",
      cancel: "Cancel"
    },
    parkingAreaSelect2: {
      parkingLotPlaceholder: "Required, please select parking lot"
    }
  },
  zh: {
    carCreateFee: {
      queryCondition: "查询条件",
      parkingSpacePlaceholder: "请填写停车场-车位，如 1-101",
      carNumPlaceholder: "请填写车牌号",
      ownerNamePlaceholder: "请填写业主名称",
      parkingSpaceStatus: "请选择车位状态",
      query: "查询",
      reset: "重置",
      vehicleCharging: "车辆收费",
      customTemplate: "自定义模板",
      customCreate: "自定义创建",
      batchCreate: "批量创建",
      buyMonthlyCard: "购买月卡",
      licensePlate: "车牌号",
      parkingLot: "停车场(单位:号)",
      parkingSpace: "车位(单位:号)",
      ownerName: "业主名称",
      contact: "联系方式",
      status: "车位状态",
      operation: "操作",
      viewCharges: "查看收费"
    },
    carCreateFeeAdd: {
      createFee: "创建费用",
      chargeScope: "收费范围",
      requiredChargeScope: "必填，请选择收费范围",
      community: "小区",
      parkingLot: "停车场",
      vehicle: "车辆",
      feeType: "费用类型",
      requiredFeeType: "必填，请选择费用类型",
      feeItem: "收费项目",
      requiredFeeItem: "必填，请选择收费项目",
      chargeAmount: "收费金额(元)",
      requiredChargeAmount: "必填，请填写收费金额(元)",
      parkingSpaceStatus: "车位状态",
      sold: "已出售",
      rented: "已出租",
      startTime: "计费起始时间",
      requiredStartTime: "必填，请填写计费起始时间",
      endTime: "计费结束时间",
      requiredEndTime: "必填，请填写计费结束时间",
      submit: "提交",
      cancel: "取消"
    },
    exportCarFeeImportExcel: {
      templateExport: "模板导出",
      parkingLot: "停车场",
      all: "全部",
      parkingLotPlaceholder: "停车场",
      feeItem: "费用项",
      export: "导出",
      cancel: "取消"
    },
    doImportCreateFee: {
      customCreateFee: "自定义创建费用",
      selectFile: "选择文件",
      requiredFile: "必填，请选择数据文件",
      import: "导入",
      cancel: "取消"
    },
    parkingAreaSelect2: {
      parkingLotPlaceholder: "必填，请选择停车场"
    }
  }
}